import { render, staticRenderFns } from "./CustomFieldsList.vue?vue&type=template&id=3e28a587"
import script from "./CustomFieldsList.vue?vue&type=script&lang=js"
export * from "./CustomFieldsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports